<template>
  <div>
    <h1 class="center">POPUP</h1>
    <h3 class="center">Ventanas flotantes</h3>
    <v-container style="">
      <div :style="{ width: !$vuetify.breakpoint.smAndDown ? '70%' : '100%' }">
        <v-btn :color="$ajustes.colorCabecera" style="color: white;"
          @click="nuevoPopup = true; formularioDialogo = true">NUEVA
          VENTANA</v-btn>
        <v-btn class="ml-3" :color="$ajustes.colorCabecera" style="color: white;"
          @click="obtenerPopups()"><v-icon>mdi-refresh</v-icon></v-btn>
      </div>
      <br>
      <v-card elevation="0" class="pa-1 pl-4 mb-1" :style="{ border: '1px solid ' + $ajustes.colorCabecera }"
        v-for="popup in popups" :key="popup.id">
        <div style="display: flex;">
          <h2 style="text-align: left;"><v-icon v-if="popup.habilitado == 1" class="mb-1 r-3" color="blue"
              small>mdi-eye-circle</v-icon>{{ popup.titulo }}
          </h2>
          <v-spacer></v-spacer>
          <div style="float: right;">
            <span class="ma-1 pointer" :style="{ fontWeight: popup.habilitado == 1 ? 'bold' : null }"
              @click="habilitarPopup(popup.id, popup.habilitado == 0 ? 1 : 0)">HABILITADO</span>
            <span class="ma-1 pointer" @click="popupDatos = popup; dialogoPopup = true">VER</span>
            <span class="ma-1 pointer"
              @click="nuevoPopup = false; popupDatos = popup; formularioDialogo = true">EDITAR</span>
            <span class="ma-1 pointer" @click="eliminarPopup(popup.id)">ELIMINAR</span>
          </div>
        </div>

      </v-card>
    </v-container>
    <formulario :propCrear="axios.crearPopup" :propActualizar="axios.actualizarPopup" :propNuevo="nuevoPopup"
      :propPopup="popupDatos" :propDialogo="formularioDialogo"
      @closeDialogo=" obtenerPopups(); formularioDialogo = false" />
    <popup :propPopup="popupDatos" :propDialogo="dialogoPopup" @cerrarDialogo="dialogoPopup = false" />
  </div>
</template>
<script>
import * as axios from "./axios";
import formulario from "./formulario";
import popup from "@/components/dialog/popup";

export default {
  components: {
    formulario,
    popup
  },
  data() {
    return {
      formularioDialogo: false,
      dialogoPopup: false,
      nuevoPopup: true,
      popupDatos: {},
      popups: [],
      axios
    };
  },
  mounted() {
    this.obtenerPopups()
  },

  created() { },
  computed: {},
  methods: {
    async obtenerPopups() {
      this.popups = []
      var response = await axios.obtenerPopups()
      this.popups = response.data
    },
    async habilitarPopup(_id, _estado) {
      const popup = {
        id: _id,
        estado: _estado,
      }
      await axios.habilitarPopup(popup)
      this.obtenerPopups()
    },
    async eliminarPopup(popupId) {
      await axios.eliminarPopup(popupId)
      this.obtenerPopups()
    },
    continuar() { },
    close() { },
  },
};
</script>
<style scoped>
.fullSize {
  margin: 0;
  padding: 0;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f0f0f0;
  overflow: hidden;
  /* Cambia la fuente a Roboto */
}

.logo {
  width: 120px;
  height: 160px;
  background-color: #333;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.splash-text {
  font-size: 36px;
  font-weight: bold;
  color: transparent;
  text-align: center;
  animation: splashAnimation 2s ease-in-out forwards;
  opacity: 0;
}

.subtitle {
  font-size: 24px;
  color: #666;
  text-align: center;
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 1s;
}

.loading-icon {
  opacity: 0;
  animation: animation 2s ease-in-out forwards;
  animation-delay: 2s;
}

@keyframes splashAnimation {
  0% {
    transform: scale(0.5);
    opacity: 0;
    color: transparent;
  }

  100% {
    transform: scale(1);
    opacity: 1;
    color: #333;
  }
}

@keyframes animation {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
